import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

const PackagesPickerError = ({ onTryAgain }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={T.translate('ERROR_LOADING')}
    >
      <LinkButton onClick={onTryAgain}>{T.translate('TRY_AGAIN')}</LinkButton>
    </EmptyState>
  );
};

PackagesPickerError.propTypes = {
  /**
   * Callback to fetch data again.
   */
  onTryAgain: PropTypes.func,
};

export default PackagesPickerError;
